import { render, staticRenderFns } from "./FolderCard.vue?vue&type=template&id=87c9636c&"
import script from "./FolderCard.vue?vue&type=script&lang=ts&"
export * from "./FolderCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports